module.exports = __webpack_public_path__ + "img/banner1.54d7d310.jpg";